export default {
  'invitationResult.title': 'Congratulations!',
  'invitationResult.subtitle':
    'You have been joined to your new organization successfully!',
  'invitationResult.login': 'Login',
};
